import {
    Alert,
    Snackbar,
} from '@mui/material';
import { type SnackBarConfig } from './interfaces/SnackBar';

type SnackBarMessageProps = {
    snackBar: SnackBarConfig,
    handleCloseSnackBar: () => void,
};

/**
 * SnackBarMessage コンポーネントは、スナックバー形式の通知メッセージを表示します。
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {SnackBarConfig} props.snackBar - スナックバーの状態と内容
 *   例: { isOpen: true, message: "保存しました", type: "success" }
 *     - isOpen: boolean - スナックバーの表示状態（例: true）
 *     - message: string - 表示するメッセージ（例: "保存しました"）
 *     - type: "success" | "error" | "warning" | "info" - メッセージの種類（例: "success"）
 * @param {() => void} props.handleCloseSnackBar - スナックバーを閉じるコールバック関数
 *   例: () => setSnackBar({ ...snackBar, isOpen: false })
 */
const SnackBarMessage: React.FC<SnackBarMessageProps> = ({
    snackBar,
    handleCloseSnackBar
}) => (
    <Snackbar
        data-testid="snackbar"
        open={snackBar.isOpen}
        onClose={handleCloseSnackBar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
        <Alert
            onClose={handleCloseSnackBar}
            severity={snackBar.type}
            sx={{ width: '100%' }}
        >
            {snackBar.message}
        </Alert>
    </Snackbar>
);

export default SnackBarMessage;